export default "__VITE_ASSET__CBq4nnvo__"